import { matchPath } from 'react-router-dom';
import {
  buildChapterBasePath,
  buildExamTipsBasePath,
  buildLegacyChapterBasePath,
  buildMockExamsPath,
  buildPracticePath,
  buildTopicsVideoPath,
  LANGUAGES,
} from '../utils/contentRoutes';

/**
 * The routes an unverified signed-in user is bounced off, listed once instead of as ~25
 * `<RequireVerified>` wrappers in App.js.
 *
 * The new practice map and all of its descendants require verified email. Keep this as
 * one exact map pattern plus one splat rather than duplicating each practice activity.
 * The older `/fide-test-topics` map remains public and is not covered by this splat.
 */
const practicePatterns = LANGUAGES.flatMap((lang) => {
  const practicePath = buildPracticePath(lang);
  return [
    practicePath,
    `${practicePath}/*`,
    `${buildChapterBasePath(lang, 'dialogue')}/video/:scenarioId`,
    `${buildLegacyChapterBasePath(lang, 'dialogue')}/video/:scenarioId`,
  ];
});

export const VERIFIED_ROUTE_PATTERNS = Array.from(
  new Set([
    ...LANGUAGES.flatMap((lang) => [
      buildMockExamsPath(lang),
      `${buildMockExamsPath(lang)}/:examType`,
      buildExamTipsBasePath(lang),
      `${buildExamTipsBasePath(lang)}/:tipId`,
      buildTopicsVideoPath(lang, ':scenarioId'),
      `/${lang}/fide-test-examples`,
    ]),
    '/pricing',
    '/fr/fide-test-example-videos',
    '/fr/fide-test-example-videos/:youtubeId',
    ...practicePatterns,
  ]),
);

export const isVerifiedRoute = (pathname) =>
  VERIFIED_ROUTE_PATTERNS.some((path) => matchPath({ path, end: true }, pathname));
